<template>
    <div class="c-pager u-mt-2xl">
        <div class="c-pager__wrap">
            <button v-if="pagination.pages.length > 1" class="c-pager__btn c-pager__prev" :class="{'is-disable': pagination.currentPage === 1}" @click="prevPage">
                <Image id="arrow-left-sm" />
            </button>
            <template v-for="i in pagination.pages" :key="i">
                <button v-if="pageToShow(i)" class="c-pager__page" :class="{'is-active': pagination.currentPage == i}" @click="pagination.currentPage = i">
                    {{ i }}
                </button>
                <span class="c-pager__separator" v-else-if="!pageToShow(i) && (i == 2 || i == pagination.pages.length - 1)">...</span>
            </template>
            <button v-if="pagination.pages.length > 1" class="c-pager__btn c-pager__next" :class="{'is-disable': pagination.currentPage === pagination.pages.length}" @click="nextPage">
                <Image id="arrow-right-sm" />
            </button>
        </div>
    </div>
</template>

<script>
import Image from 'Image.vue';
export default {
    name: 'Pager',
    components: {
        Image
    },
    data() {
        return {
           
        }
    },
    props: {
        pagination: {
            type: Object,
            required: true
        }
    },
    methods: {
        pageToShow(p) {
            if (p === 1 || p === this.pagination.pages.length) {
                return true;
            }
            if (p >= parseInt(this.pagination.currentPage - 2) && p <= parseInt(this.pagination.currentPage) + 2) {
                return true;
            }
            return false;
        },
        prevPage() {
            if (this.pagination.currentPage > 1) {
                this.pagination.currentPage--;
            }
        },
        nextPage() {
            if (this.pagination.currentPage < this.pagination.pages.length) {
                this.pagination.currentPage++;
            }
        }
    }
}
</script>